export default __webpack_public_path__ + "static/media/Rectangle_761.f5e6d838.webp";